/**
 * resolveTriageMailbox — the ONE place the add-in decides which mailbox key
 * rides on analyze / prefill-store / email-state calls (story 26727).
 *
 * The substrate's `email_analysis` row is now keyed on
 * `(internet_message_id, mailbox_address)`. Two callers disagreed about that
 * second half before this story: `buildAnalyzeEmailPayload` sent the
 * signed-in user's own SMTP (`Office.context.mailbox.userProfile.emailAddress`,
 * via `useMailboxItem`'s `mailboxAddress`), while `reanalyzeEmail` sent the
 * detected SHARED target when one existed. Under the old single-column key
 * that split was invisible; under the widened key it is exactly the
 * collision the story exists to prevent — one email, two rows, keyed
 * differently by two paths that both call themselves "the mailbox".
 *
 * The right key is the mailbox the message was actually READ FROM — the
 * shared mailbox when `detectTargetMailbox` resolved one (the same value
 * `getSharedMailboxLaunchTarget()` already exposes for the launch path),
 * else the signed-in reader's own address. Lower/trimmed to match the
 * substrate's own normalisation (`mailbox_watch_registry.normalize_key`) —
 * `Foo@Bar.com` from one call and `foo@bar.com` from another must resolve to
 * the SAME row, not two.
 */
import { getSharedMailboxLaunchTarget } from "./sharedMailboxTarget";

export interface TriageMailboxSource {
  mailboxAddress?: string | null;
}

export function resolveTriageMailbox(
  src: TriageMailboxSource,
): string | null {
  const shared = getSharedMailboxLaunchTarget();
  const raw = shared?.targetMailbox ?? src.mailboxAddress ?? null;
  const trimmed = (raw ?? "").trim().toLowerCase();
  return trimmed || null;
}
